import { Box, HStack, Text, VStack } from '@chakra-ui/react'
import { Button, Modal } from 'uikit'
import { useCallback } from 'react'
import { MdInfo } from 'react-icons/md'
import { useBoolean } from 'react-use'
import { getDateTimeToSubmit } from 'shared/utils/dateFormatting'
import { Tooltip } from 'uikit'
import { useClearChache } from '../hooks/useClearChache'
import { useFetchStats } from '../hooks/useFetchStats'
import { useFetchUserBalance } from '../hooks/useFetchUserBalance'

export const PaymentsActions = ({ user, filters }) => {
  const {
    refetch: fetchUserBalance,
    isLoading: userBalanceIsLoading,
    data: balance,
  } = useFetchUserBalance(user.id)

  const { mutate: fetchStats, data: stats, isLoading: statsIsLoading } = useFetchStats()
  const [IsOpenLimitModal, setOpenLimitModal] = useBoolean(false)
  const { mutate: clearLimit, isLoading: limitIsClearing } = useClearChache(user.id)

  const onClearLimit = useCallback(() => {
    clearLimit(undefined, {
      onSuccess: () => {
        setOpenLimitModal(false)
      },
    })
  }, [])

  const onShowBalance = useCallback(() => {
    fetchUserBalance()
  }, [])

  const onUpdateStats = () => {
    const { paymentDateFrom, paymentDateTo, paymentState } = filters

    fetchStats({
      payerPhone: user.phone,
      paymentDateFrom: paymentDateFrom ? getDateTimeToSubmit(paymentDateFrom) : undefined,
      paymentDateTo: paymentDateTo ? getDateTimeToSubmit(paymentDateTo) : undefined,
      paymentState: paymentState !== 'all' || !paymentState ? paymentState : undefined,
    })
  }

  const actionStatsIsEnabled = filters?.paymentState

  return (
    <>
      <VStack gap={4} alignItems="stretch" width="full" mb="20px">
        <Box border="1px solid" borderColor="gray.300" p={4} borderRadius="20px">
          <Text fontSize="0.82rem" color="gray.400" mb={2}>
            Действия
          </Text>
          <Button
            w="full"
            colorPalette="gray"
            onClick={() => setOpenLimitModal(true)}
            loading={limitIsClearing}
          >
            Сбросить лимит
          </Button>
        </Box>

        <Box>
          <HStack gap={1}>
            <Text fontSize="18px">Статистика</Text>
            <Tooltip content="Для подсчета ежемесячных лимитов платежей необходимо выбрать диапазон дат с первого по последнее число месяца и статус платежа (Проведен)">
              <Box color="orange.300">
                <MdInfo cursor="pointer" mb="20px" />
              </Box>
            </Tooltip>
          </HStack>
          <Box>
            <Text fontSize="13px">{`Платежей найдено: ${
              stats?.numberOfPaymentsFound ?? ' - '
            }`}</Text>
            <Text fontSize="13px">{`Сумма платежей: ${
              stats?.paymentsTotalRub ? stats?.paymentsTotalRub + ' руб' : ' - '
            }`}</Text>
            <Text fontSize="13px">{`Сумма комиссий: ${
              stats?.commissionsTotalRub ? stats?.commissionsTotalRub + ' руб' : ' - '
            }`}</Text>
            <Text fontSize="13px">{`Сумма платежей c учетом комиссий: ${
              stats?.paymentsAndCommissionsTotalRub
                ? stats?.paymentsAndCommissionsTotalRub + ' руб'
                : ' - '
            }`}</Text>
          </Box>
          <Button
            disabled={!actionStatsIsEnabled}
            loading={statsIsLoading}
            mt="15px"
            size="sm"
            width="100%"
            onClick={onUpdateStats}
          >
            {!stats ? 'Получить' : 'Обновить'}
          </Button>
        </Box>

        <Box>
          <Box fontSize="14px" mb="10px">
            <Text fontWeight="bold">Баланс счета СКБ:</Text>
            <Box>
              <Text as="span">Все средства на счете (Saldo): </Text>
              <Text as="span" fontWeight="bold">
                {balance?.saldo ?? ' - '}
              </Text>
            </Box>
            <Box>
              <Text as="span">Доступные средства (Free no shadow): </Text>
              <Text as="span" fontWeight="bold">
                {balance?.freeNoShadow ?? ' - '}
              </Text>
            </Box>
            <Text fontWeight="bold">Локальный баланс:</Text>
            <Box>
              <Text as="span">Дебет: </Text>
              <Text as="span" fontWeight="bold">
                {balance?.localDebet ?? ' - '}
              </Text>
            </Box>
            <Box>
              <Text as="span">Резерв: </Text>
              <Text as="span" fontWeight="bold">
                {balance?.localReserve ?? ' - '}
              </Text>
            </Box>
          </Box>
          <HStack>
            <Button
              colorPalette="orange"
              size="sm"
              onClick={onShowBalance}
              loading={userBalanceIsLoading}
            >
              Показать баланс
            </Button>
          </HStack>
        </Box>
      </VStack>

      <Modal
        isOpen={IsOpenLimitModal}
        onClose={() => setOpenLimitModal(false)}
        title="Сбросить лимит"
      >
        <Text>Данное действие нельзя будет отменить.</Text>
        <Box pt="30px">
          <Button colorPalette="orange" loading={limitIsClearing} onClick={onClearLimit}>
            Продолжить
          </Button>
        </Box>
      </Modal>
    </>
  )
}
